import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
    Image
} from 'semantic-ui-react';
import {
    Container,
    Row,
    Col
} from 'design-react-kit';
import FacebookSVG from '../../../theme/images/ico-facebook.svg';
import InstagramSVG from '../../../theme/images/ico-instagram.svg';
import LinkedinSVG from '../../../theme/images/ico-linkedin.svg';
import TwitterSVG from '../../../theme/images/ico-x.svg';
import YoutubeSVG from '../../../theme/images/ico-youtube.svg';
import { getUnibaFooter } from 'design-comuni-plone-theme/actions';
import { getUnibaFooterLinksConfig } from 'design-comuni-plone-theme/actions';
import { getViewName } from 'design-comuni-plone-theme/components';
import config from '@plone/volto/registry';
import FooterMainUnibaSkeleton from './FooterMainUnibaSkeleton';

class FooterMainUniba extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parsedColumns: [],
            parsedLinks: [],
        };
    };

    componentDidMount() {
        this.props.getUnibaFooter();
        this.props.getUnibaFooterLinksConfig();
    };

    componentDidUpdate(prevProps) {
        if (
            prevProps.unibaFooterLoading &&
            !this.props.unibaFooterLoading &&
            this.props.unibaFooterResult
        ) {
            const { unibaFooterResult, lang } = this.props;

            if ('url' in unibaFooterResult) {
                const footerEndpoint = getViewName(unibaFooterResult['url']);
                let fullEndpoint;
                if (config.settings.isMultilingual) {
                    fullEndpoint = `${window.location.origin}/++api++/${lang}/${footerEndpoint}`;
                } else {
                    fullEndpoint = `${window.location.origin}/++api++/${footerEndpoint}`;
                }

                fetch(fullEndpoint)
                    .then((response) => response.text())
                    .then((html) => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        const columns = doc.querySelectorAll('div.col-sm-4.col-md-3');
                        const gridColumns = Array.from(columns).map((column, index) => {
                            const listItems = column.querySelectorAll('ul.list-unstyled li');
                            return (
                                <Col className="list-unstyled ps-4 pb-3" key={index} sm="12" md="4" lg="3">
                                    {Array.from(listItems).map((listItem, idx) => (
                                        <Row key={idx}>
                                            <div dangerouslySetInnerHTML={{ __html: listItem.innerHTML }} />
                                        </Row>
                                    ))}
                                </Col>
                            );
                        });
                        this.setState({ parsedColumns: gridColumns });
                    })
                    .catch((error) =>
                        console.error('Error fetching the UnibaFooter content:', error)
                    );
            } else if ('content' in unibaFooterResult) {
                this.setState({
                    parsedColumns: (
                        <div dangerouslySetInnerHTML={{ __html: unibaFooterResult['content'] }} />
                    ),
                });
            } else {
                this.setState({ parsedColumns: null });
            }
        }

        if (
            prevProps.unibaFooterLinksConfigLoading &&
            !this.props.unibaFooterLinksConfigLoading &&
            this.props.unibaFooterLinksConfigResult
        ) {
            this.setState({ parsedLinks: this.props.unibaFooterLinksConfigResult?.items });
        }
    };

    render() {
        const { parsedColumns, parsedLinks } = this.state;
        const { intl } = this.props;

        const intl_facebook = intl.formatMessage(
            { id: 'socialPageAlt' },
            { social: 'Facebook' }
        );
        const intl_instagram = intl.formatMessage(
            { id: 'socialPageAlt' },
            { social: 'Instagram' }
        );
        const intl_twitter = intl.formatMessage(
            { id: 'socialPageAlt' },
            { social: 'Twitter/X' }
        );
        const intl_youtube = intl.formatMessage(
            { id: 'socialPageAlt' },
            { social: 'Youtube' }
        );
        const intl_linkedin = intl.formatMessage(
            { id: 'socialPageAlt' },
            { social: 'LinkedIn' }
        );

        if (!parsedColumns) {
            return <FooterMainUnibaSkeleton />;
        }
        return (
            <div className="portal-main-footer bg-primary">
                <div className="container position--relative">
                    <Container>
                        <Row className="pt-2 pb-2">
                            <Col key="links1" sm="12" lg="3" >
                                <Container className="sedi">
                                    <Row className="p-0 justify-content-center" key="1">
                                        <Col key="sedi1" className="col-auto">
                                            <a href="https://www.uniba.it/ateneo/sede-di-brindisi/">
                                                Uniba Brindisi
                                            </a>
                                        </Col>
                                        <Col key="sedi2" className="col-auto p-0">
                                            &middot;
                                        </Col>
                                        <Col key="sedi3" className="col-auto">
                                            <a href="https://www.uniba.it/ateneo/sede-di-taranto/">
                                                Uniba Taranto
                                            </a>
                                        </Col>
                                    </Row>
                                </Container>
                                <Container className="socials">
                                    <Row className="p-0 justify-content-center">
                                        <Col className="col-auto socials-item" key="socials1">
                                            <a
                                                href="http://www.facebook.com/pages/Universita-degli-Studi-di-Bari-Aldo-Moro/142796619110027"
                                                aria-label={intl_facebook}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Image src={FacebookSVG} alt="Facebook" width="30" height="30" />
                                            </a>
                                        </Col>
                                        <Col className="col-auto socials-item" key="socials2">
                                            <a
                                                href="https://www.instagram.com/unibaofficial"
                                                aria-label={intl_instagram}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Image src={InstagramSVG} alt="Instagram" width="30" height="30" />
                                            </a>
                                        </Col>
                                        <Col className="col-auto socials-item" key="socials3">
                                            <a
                                                href="http://www.twitter.com/unibait"
                                                aria-label={intl_twitter}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Image src={TwitterSVG} alt="Twitter/X" width="30" height="30" />
                                            </a>
                                        </Col>
                                        <Col className="col-auto socials-item" key="socials4">
                                            <a
                                                href="https://www.youtube.com/user/unialdomoro"
                                                aria-label={intl_youtube}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Image src={YoutubeSVG} alt="Youtube" width="30" height="30" />
                                            </a>
                                        </Col>
                                        <Col className="col-auto socials-item" key="socials5">
                                            <a
                                                href="https://www.linkedin.com/school/universit-degli-studi-di-bari"
                                                aria-label={intl_linkedin}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Image src={LinkedinSVG} alt="LinkedIn" width="30" height="30" />
                                            </a>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                            {parsedColumns ? (
                                parsedColumns
                            ) : (
                                <Row>
                                    {[...Array(3)].map((_, idx) => (
                                        <Col key={idx} sm="12" lg="3" md="4" style={{ minHeight: 150 }} />
                                    ))}
                                </Row>
                            )}
                        </Row>
                        <Row className="ps-3 pe-3">
                            <Col key="footer1">
                                <p className="text-center">
                                    Università degli studi di Bari Aldo Moro - Piazza Umberto I - 70121
                                    Bari (Italy) - P.I.01086760723 | C.F.80002170720
                                </p>
                                {parsedLinks && (
                                    <p className="text-center">
                                        {parsedLinks
                                            ?.filter(item => item.abilitato)
                                            .map((item, idx, arr) => {
                                                let content;
                                                const label = item.label || item.value || "";

                                                switch (item.type) {
                                                    case 'email':
                                                        content = <a key={idx} href={`mailto:${item.value}`}>{label}</a>;
                                                        break;
                                                    case 'link':
                                                        content = <a key={idx} href={item.value} target="_blank" rel="noopener noreferrer">{label}</a>;
                                                        break;
                                                    case 'statico':
                                                        content = <span key={idx}>{label}</span>;
                                                        break;
                                                    default:
                                                        content = <span key={idx}>{label}</span>;
                                                }

                                                // aggiungi il separatore " • " se non è l'ultimo elemento
                                                if (idx < arr.length - 1) {
                                                    return <React.Fragment key={idx}>{content}&nbsp;&nbsp;•&nbsp;&nbsp;</React.Fragment>;
                                                }

                                                return content;
                                            })}
                                    </p>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        );
    };
}

FooterMainUniba.propTypes = {
    unibaFooterResult: PropTypes.object,
    unibaFooterLoading: PropTypes.bool,
    unibaFooterLinksConfigResult: PropTypes.object,
    unibaFooterLinksConfigLoading: PropTypes.bool,

    getUnibaFooter: PropTypes.func.isRequired,
    getUnibaFooterLinksConfig: PropTypes.func.isRequired,

    intl: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => ({
    unibaFooterResult: state.unibaFooter.result,
    unibaFooterLoading: state.unibaFooter.loadingResults,
    unibaFooterLinksConfigResult: state.unibaFooterLinksConfig.result,
    unibaFooterLinksConfigLoading: state.unibaFooterLinksConfig.loadingResults,
    lang: state.intl.locale,
});

const mapDispatchToProps = {
    getUnibaFooter,
    getUnibaFooterLinksConfig
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(FooterMainUniba));